import { TextField } from "@mui/material";
import { useController } from "react-hook-form";

export function FormTextField({
  name,
  control={},
  children,
  ...props
}) {
  const {
    field,
    fieldState: { isTouched, isDirty },
    formState: { touchedFields, dirtyFields }
  } = useController({
    name,
    control
  });

  return (
    <TextField
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      inputRef={field.ref}
      {...props}
    >
      {children}
    </TextField>
  );
}